import { render, staticRenderFns } from "./IconMessageBlock.vue?vue&type=template&id=4b530e84&scoped=true&"
import script from "./IconMessageBlock.vue?vue&type=script&lang=ts&"
export * from "./IconMessageBlock.vue?vue&type=script&lang=ts&"
import style0 from "./IconMessageBlock.vue?vue&type=style&index=0&id=4b530e84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b530e84",
  null
  
)

export default component.exports